import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.topPanel}>
          <div className={styles.brandCol}>
            <Link to="/" className={styles.logo}>
              LeanWeek<span>AI</span>
            </Link>

            <p className={styles.tagline}>
              Private AI-powered weekly fitness planning for practical,
              sustainable fat-loss support.
            </p>

            <div className={styles.trustBadge}>
              <span className={styles.trustDot} />
              Local-First Architecture
            </div>
          </div>

          <div className={styles.linksGrid}>
            <div className={styles.linkCol}>
              <h4>Product</h4>
              <ul>
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/waitlist">Early Access</Link></li>
              </ul>
            </div>

            <div className={styles.linkCol}>
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
              </ul>
            </div>

            <div className={styles.linkCol}>
              <h4>Legal</h4>
              <ul>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/data-deletion">Data Deletion</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.bottomBar}>
          <p className={styles.copyright}>
            © {currentYear} LeanWeek-AI. All rights reserved.
          </p>

          <p className={styles.disclaimer}>
            LeanWeek-AI is for general fitness support and is not a medical
            app. Consult a qualified healthcare professional before beginning a
            new exercise program.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;